import styled from 'styled-components';

export const SelectBox = styled.div`
  position: relative;
`;

export const SelectIcon = styled.div`
  position: absolute;
  top: 12px;
  left: 16px;
  color: #00A2FF;
  line-height: 0;
`;

export const SelectField = styled.select<{ $isErrored?: boolean, $hasValue: boolean }>`
  width: 100%;
  height: 48px;
  padding: 0 48px;
  border: 2px solid ${({ $isErrored }): string => ($isErrored ? '#E52E59' : '#E6E6E6')};
  border-radius: 48px;
  font-size: 14px;
  color: ${({ $hasValue }): string => ($hasValue ? '#4B5057' : 'rgba(75, 80, 87, .3)')};
  background-color: #FFFFFF;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';

  &:hover {
    border-color: ${({ $isErrored }): string => ($isErrored ? '#E52E59' : '#C4C8CC')};
  }

  &:focus {
    outline: none;
    border-color: ${({ $isErrored }): string => ($isErrored ? '#E52E59' : '#00A2FF')};
  }

  &:disabled {
    border-color: #E6E6E6;
    background-color: #F6F6F6;
  }

  & + ${SelectIcon} {
    color: ${({ $hasValue }): string => ($hasValue ? '#4B5057' : 'rgba(75, 80, 87, .3)')};
  }

  &:focus + ${SelectIcon} {
    color: #00A2FF;
  }
`;

export const SelectArrow = styled.div`
  position: absolute;
  top: 12px;
  right: 16px;
  line-height: 0;
  pointer-events: none;
`;

SelectBox.displayName = 'SelectBox';
SelectField.displayName = 'SelectField';
SelectIcon.displayName = 'SelectIcon';
SelectArrow.displayName = 'SelectArrow';
